<template>
  <div class="PricePublic mb-20 desk:mb-24">
    <div class="flex items-end gap-6">
      <div class="type-headline-lg font-karla font-semibold leading-single">
        <span v-if="areaPrice">
          <span
            :class="{
              'text-text-brandStrong': isCampaignPrice
            }"
          >
            {{ useLocalizedCurrency(areaPrice) }}/{{ unitDisplay }}
          </span>
          <span
            v-if="isCampaignPrice"
            class="type-headline-sm inline-block pr-4 pl-8 line-through"
          >{{ useLocalizedCurrency(areaPriceBeforeDiscount) }}/{{ unitDisplay }}</span>
        </span>
        <span v-else>{{ globalContent.getDisplayIncVat ? activeVariant.priceInfo.priceDisplay : activeVariant.priceInfo.priceBeforeVatDisplay }}</span>
      </div>
      <span class="text-text-subtle type-sm leading-single pb-2">
        {{ globalContent.getDisplayIncVat ? $t('price.incVat.shown') : $t('price.exVat.shown') }}
      </span>
    </div>
    <div v-if="shouldUseArea" class="mt-6 text-text-subtle type-sm leading-single">
      {{ $t('areaConvert.pricePerPack', { price: useLocalizedCurrency(props.activeVariant.priceInfo.price) }) }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { ProductModel } from '~/models/product';
import { ProductVariantModel } from '~/models/productVariant';
import usePackageAreaConverter from '~/composeables/usePackageAreaConverter';
import { useGlobalContentStore } from '~/store/globalContent';
import { useLocalizedCurrency } from '~/composeables/useLocalizedCurrency';
const globalContent = useGlobalContentStore();

const props = defineProps<{
  productItem: ProductModel,
  activeVariant: ProductVariantModel,
}>();

const { unitDisplay, shouldUseArea, convertPackagePriceToAreaPrice } = usePackageAreaConverter(toRef(()=>props.activeVariant));

const areaPrice = computed(()=> {
  if (shouldUseArea.value) {
    return globalContent.getDisplayIncVat ? convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.price) : convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.priceBeforeVat);
  }
  return null;
});

const areaPriceBeforeDiscount = computed(()=> {
  if (shouldUseArea.value) {
    return globalContent.getDisplayIncVat ? convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.priceBeforeDiscount) : convertPackagePriceToAreaPrice(props.activeVariant.priceInfo.priceBeforeDiscountBeforeVat);
  }
  return null;
});

// isCampaignPrice
const isCampaignPrice = computed(()=> {
  return (props.activeVariant.isCampaignPrice &&
          areaPriceBeforeDiscount.value &&
          areaPrice.value !== areaPriceBeforeDiscount.value);
});

</script>

<style scoped lang="postcss">
</style>
